import { z } from 'zod';

/**
 * A stored form schema, read leniently: a field is required to name its `key`
 * and `type` and nothing else, and every other property passes through
 * verbatim. A version published under a field type this build does not know is
 * returned as it was stored, never rejected — see
 * docs/decisions/0012-versioned-form-schema-compiled-to-zod.md.
 *
 * It lives beside `moneySchema` and the pagination primitives because three
 * contracts share it — the campaign's own, the donation's and the portal's —
 * and the portal's entry point may not reach into an administrator's contract
 * to find it.
 */
export const formSchemaDocumentSchema = z.object({
  version: z.number().int().min(0),
  fields: z.array(z.looseObject({ key: z.string(), type: z.string() })),
});

export type FormSchemaDocument = z.infer<typeof formSchemaDocumentSchema>;
